'use strict';
const angular = require('angular');
const uiRouter = require('angular-ui-router');
import LoginController from './login.controller';

export default angular.module('terrappApp.login', [uiRouter])
  // .controller('LoginController', LoginController)
  .component('login', {
    template: require('./login.html'),
    controller: LoginController,
    controllerAs: 'vm'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/account/login/index.ts